import { List, Map } from 'immutable';
import shortid from 'shortid';

import types from './types';
import * as gloablTypes from '../../types';

const initialState = Map({
  recentConfigs: List(),
  recentAndSavedConfigsLoaded: false,
  savedConfigs: List(),
});

const addMissingId = (config) => {
  if (!config.id) {
    return Map({ ...config, id: shortid.generate() });
  }

  return Map(config);
};

const recentAndSavedConfigsReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case gloablTypes.METADATA_GET.REQUEST:
      return state.set('recentAndSavedConfigsLoaded', false);

    case gloablTypes.METADATA_GET.SUCCESS: {
      const metadata = payload.items.reduce((result, { key, value }) => (
        { [key]: value, ...result }
      ), {});

      return state.merge({
        recentConfigs: metadata.recent_configs ?
          List(metadata.recent_configs.map(addMissingId)) : List(),
        recentAndSavedConfigsLoaded: true,
        savedConfigs: metadata.saved_configs ? List(metadata.saved_configs) : List(),
      });
    }

    case types.RECENT_CONFIGS_PUT.SUCCESS: {
      if (!payload.item) return state;

      let recents = List(payload.item.value);
      recents = recents.map((config) => Map(config));
      return state.set('recentConfigs', recents);
    }

    case types.SAVED_CONFIGS_PUT.SUCCESS: {
      if (!payload.item) return state;

      let saved = List(payload.item.value);
      saved = saved.map((config) => Map(config));
      return state.set('savedConfigs', saved);
    }

    default:
      return state;
  }
};

export default recentAndSavedConfigsReducer;
export { initialState };
